import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {FirmUsersService} from '../services/firm-users.service';

@Component({
  selector: 'app-firm-users',
  templateUrl: './firm-users.component.html',
  styleUrls: ['./firm-users.component.css']
})
export class FirmUsersComponent implements OnInit {

  @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
  @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
  @ViewChild('errorSwal') private errorSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;
  private firmId: string;
  public users = [];
  public firm: any;
  public searchText;
  emailValidError;
  constructor(private usersService: FirmUsersService, private router: Router, private spinner: NgxSpinnerService) {
  }

  public selectedId;
  public selectedUser = {name: '', _id: '', username: '', password: '', phoneNumber: ''};

  ngOnInit() {
    this.spinner.show();
    this.firm = localStorage.getItem('firm');
    this.firmId = localStorage.getItem('firmId');
    this.getUsersByFirm(this.firmId);
  }

  getUsersByFirm(firmId: string) {
    this.usersService.getAllFirmUsers(firmId).subscribe(res => {
      console.log(res);
      this.users = res;

      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  createFirmUser(name, username, phoneNumber) {
    if (name === '' || name === undefined || username === '' || username === undefined|| phoneNumber === '' || phoneNumber === undefined) {
      this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    const firmUser = {
      name: name,
      username: username,
      firm: this.firmId,
      phoneNumber: phoneNumber
    };
    this.usersService.createFirmUser(firmUser).subscribe(res => {
      console.log(res);
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.closeCreateModal.nativeElement.click();
      this.getUsersByFirm(this.firmId);
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  deleteUser(id) {
    if (id === '' || id === undefined) {
      this.errorSwal.title = 'User id alınamadı!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    this.usersService.deleteFirmUser(id).subscribe(res => {
      console.log(res);
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.getUsersByFirm(this.firmId);
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  updateUser(name, username, phoneNumber) {
    if (name === '' || name === undefined || username === '' || username === undefined || phoneNumber === '' || phoneNumber === undefined) {
      this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    const User = {
      name: name,
      username: username,
      firm: this.firmId,
      phoneNumber: phoneNumber
    };

    this.usersService.updateFirmUser(User, this.selectedId).subscribe(res => {
      console.log(res);
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.closeUpdateModal.nativeElement.click();
      this.getUsersByFirm(this.firmId);
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  getUsersById(id) {
    this.spinner.show();
    this.usersService.getFirmUser(id).subscribe(res => {
      console.log(res);
      this.selectedUser = res;
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }

  selected(id) {
    this.selectedId = id;
    this.getUsersById(id);
  }

  validateEmail(email) {
    this.emailValidError = false;
    const valid = String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    if (!valid) {
        this.emailValidError = true;
    }
  }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-users/firm-users.component.ts